// GDPR-compliant consent store.
// - Scripts must check `canUse("analytics")` / `canUse("marketing")`
//   before loading third-party trackers.
// - Consent is persisted in localStorage.
// - Users can re-open preferences anytime via `openConsent()`.

const KEY = "geovinum.cookie-consent.v1";
const OPEN_EVENT = "geovinum:open-consent";
const CHANGE_EVENT = "geovinum:consent-changed";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  const payload = {
    essential: true,
    analytics: Boolean(consent.analytics),
    marketing: Boolean(consent.marketing),
    decidedAt: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: payload }));
  return payload;
}

export function acceptAll() {
  return saveConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  return saveConsent({ analytics: false, marketing: false });
}

export function canUse(category) {
  const c = getConsent();
  if (!c) return false;
  if (category === "essential") return true;
  return Boolean(c[category]);
}

export function openConsent() {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export const CONSENT_EVENTS = { OPEN: OPEN_EVENT, CHANGE: CHANGE_EVENT };
